export default __webpack_public_path__ + "static/media/bleble.46196b3e.png";